import React, { Component } from 'react';
import styles from 'components/LogView/LogView.scss';

export default class LogView extends Component {
  componentWillReceiveProps(nextProps) {
    if(nextProps.autoscroll) {
      setTimeout(() => {
        if(this.terminal) {
          this.terminal.scrollTop = this.terminal.scrollHeight;
        }
      }, 100);
    }
  }

  render() {
    return (
      <div className={[styles.body, this.props.fixed ? styles.fixed : ''].join(' ')}>
        <div className={[styles.terminal, this.props.withCursor ? styles.withCursor : ''].join(' ')}>
          <div ref={(r) => this.terminal = r}>
            {this.props.children}
          </div>
        </div>
      </div>
    );
  }
}